<!-- Icon-only share button pinned to the upper-right corner of a card.
     The parent card must be position: relative. -->
<script setup>
defineProps({ copied: { type: Boolean, default: false } })

defineEmits(['share'])
</script>

<template>
    <button type="button" class="share-star-btn" aria-label="Share" :title="copied ? 'Copied!' : 'Share'" @click.stop="$emit('share')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="3" r="1.5"/><circle cx="12" cy="13" r="1.5"/><circle cx="4" cy="8" r="1.5"/><line x1="10.5" y1="3.87" x2="5.5" y2="7.13"/><line x1="5.5" y1="8.87" x2="10.5" y2="12.13"/></svg>
        <span v-if="copied" class="share-star-btn__copied" role="status">Copied!</span>
    </button>
</template>

<style scoped>
.share-star-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 3;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    /* opaque-ish dark fill so the button reads on light covers (e.g. series logos) too */
    background: rgba(10,10,14,0.65);
    border: 1px solid rgba(255,255,255,0.18);
    border-radius: 50%;
    color: #ddd;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.share-star-btn:hover { background: rgba(10,10,14,0.85); border-color: rgba(255,255,255,0.35); color: #fff; }
.share-star-btn svg { width: 13px; height: 13px; flex-shrink: 0; }
.share-star-btn__copied {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    padding: 3px 8px;
    background: rgba(0,0,0,0.85);
    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 6px;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    white-space: nowrap;
}
</style>
